import { Form, notification, Select, Upload } from 'antd';
import { UploadOutlined } from '@ant-design/icons';
import { useState } from 'react';
import APIClient from '../api/api';
import { useForm } from 'antd/es/form/Form';
import { Button } from '../components/ui';
import { PageBody, PageHead } from '../layout';

const UploadSalesHistory = () => {
  const [uploading, setUploading] = useState(false);
  const [form] = useForm();

  const normFile = (e: any) => {
    if (Array.isArray(e)) {
      return e;
    }
    return e?.fileList;
  };

  async function onFinish(values: any) {
    try {
      setUploading(true);
      const resp = await APIClient.uploadSalesHistory({
        account: values.account,
        fileType: values.fileType,
        file: values.upload[0].originFileObj,
      });
      notification.success({
        message: 'File successfully uploaded, ' + resp.recordsLoaded + ' records loaded.',
      });
      form.resetFields();
    } catch (e) {
      notification.error({ message: 'Failed to upload at this time.' });
    } finally {
      setUploading(false);
    }
  }

  function customRequest(req: any) {
    req.onSuccess(null);
  }

  return (
    <>
      <PageHead title="Upload Sales History" subtitle="Import sales records from a venue export." />
      <PageBody>
        <div className="max-w-[640px]">
          <Form form={form} onFinish={onFinish} layout="vertical">
            <Form.Item
              label="File Type"
              name="fileType"
              rules={[{ required: true, message: 'File type is required' }]}
            >
              <Select style={{ width: '300px' }}>
                <Select.Option value="dan">Dan</Select.Option>
                <Select.Option value="sedo">Sedo</Select.Option>
                <Select.Option value="atom">Atom/Squadhelp</Select.Option>
              </Select>
            </Form.Item>
            <Form.Item
              label="Account"
              name="account"
              rules={[{ required: true, message: 'Account is required' }]}
            >
              <Select style={{ width: '300px' }}>
                <Select.Option value="dan">dan</Select.Option>
                <Select.Option value="squadhelp">squadhelp</Select.Option>
                <Select.Option value="parity-software">parity-software (sedo)</Select.Option>
                <Select.Option value="parity-wholesale">parity-wholesale (sedo)</Select.Option>
              </Select>
            </Form.Item>
            <Form.Item
              name="upload"
              label="Upload"
              valuePropName="fileList"
              rules={[{ required: true, message: 'File required' }]}
              getValueFromEvent={normFile}
            >
              <Upload customRequest={customRequest}>
                <Button variant="ghost" iconLeft={<UploadOutlined />}>
                  Click to Upload
                </Button>
              </Upload>
            </Form.Item>
            <Form.Item>
              <Button variant="primary" type="submit" loading={uploading}>
                Upload
              </Button>
            </Form.Item>
          </Form>
        </div>
      </PageBody>
    </>
  );
};

export default UploadSalesHistory;
